import styled from "styled-components";

const TopNav = styled.div`
  display: flex;
`;

export default TopNav;
